export default "__VITE_ASSET__06d50b3b__"